import {useCallback} from 'react';
import {ManagerRef} from '../types';

export function useExpandPanel(ref: ManagerRef, cb?: VoidFunction, immediate?: boolean) {
	return useCallback(() => ref.current?.expandPanel(cb, immediate), [ref, cb, immediate]);
}
